export type CameraAttribution =
  | 'UCSD'
  | 'ALERTWILDFIRE'
  | 'UO'
  | 'UNR'
  | 'ALERTWEST'
  | 'HPWREN';

export const CAMERA_ATTRIBUTION_TEXT: Record<CameraAttribution, string> = {
  UCSD: 'ALERTCalifornia | UC San Diego',
  ALERTWILDFIRE: 'ALERT Wildfire',
  UO: 'ALERTWest | OHAZ | University of Oregon',
  UNR: 'ALERTWest | Nevada Seismological Laboratory | University of Nevada, Reno',
  ALERTWEST: 'ALERTWest',
  HPWREN: 'ALERTCalifornia | UC San Diego',
};

export const CAMERA_ATTRIBUTION_LOGO_URL_LIGHT: Record<
  CameraAttribution,
  string
> = {
  UCSD: '/images/camera-providers/alertca.png',
  ALERTWEST: '/images/camera-providers/alertwest.png',
  ALERTWILDFIRE: '/images/camera-providers/alertwildfire.png',
  UO: '/images/camera-providers/alertwestuo.png',
  UNR: '/images/camera-providers/alertwestunr.png',
  HPWREN: '/images/camera-providers/alertca.png',
};

export const CAMERA_ATTRIBUTION_LOGO_URL_DARK: Record<
  CameraAttribution,
  string
> = {
  UCSD: '/images/camera-providers/alertca-white.png',
  ALERTWEST: '/images/camera-providers/alertwest-white.png',
  ALERTWILDFIRE: '/images/camera-providers/alertwildfire-white.png',
  UO: '/images/camera-providers/alertwestuo-white.png',
  UNR: '/images/camera-providers/alertwestunr-white.png',
  HPWREN: '/images/camera-providers/alertca-white.png',
};
